import React from 'react';

import DateHelper from '../../../helpers/dateHelper';
import WeekHelper from '../../../helpers/weekHelper';
import { PropertyNameIndexer } from '../../../typescript/customTypes';
import { Week } from '../../../typescript/dateTypes';
import { StoreSettings, StoreTimesheet } from '../../../typescript/storeTypes';

export const WeekSelection = ((props: Props) => {    
    const onWeekClick = (week: Week): void => {
        if (WeekHelper.hasWeekNumber(props.timesheet, props.settings)) {
            return;
        }

        if(props.selectedWeek && props.selectedWeek.weekNumber === week.weekNumber) {
            props.updateSelectedWeek(undefined);
        } else {
            props.updateSelectedWeek(week);
        }        
    };

    const isWeekSelected = (week: Week): boolean => {
        if (props.selectedWeek) {
            return props.selectedWeek.weekNumber === week.weekNumber;
        }
        
        return false;
    };

    return (
        <div className="week-selection form-group">
            <div className="label-with-error-tooltip">
                <label data-required={props.errors['selectedWeek']} className="digital-signing-modal__required">Select week:</label>
                <div data-required={props.errors['selectedWeek']}   className="error-tooltip"><i className="fas fa-info-circle" /></div>
            </div>
            <div className="weeks-container">
                {props.timesheet.period.weeks.map(week =>
                    <div key={week.weekNumber} className="week-select"
                        onClick={() => onWeekClick(week)}>
                        <div className={'week-select-checkbox' + (WeekHelper.hasWeekNumber(props.timesheet, props.settings) ? ' readonly': '')}>
                            <input type="checkbox"
                                    checked={isWeekSelected(week)}
                                    readOnly />
                        </div>
                        <div className="week-select-number">
                            <div className="week-select-weeknumber">Week {week.weekNumber}</div>
                            <div className="week-period">
                                <div className="start-date week-period-date">
                                    {DateHelper.getFormattedDate(week.startDate,'/')}
                                </div>
                                <div className="week-period-dash">-</div>
                                <div className="end-date week-period-date">
                                    {DateHelper.getFormattedDate(week.endDate,'/')}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

type Props = {
    timesheet: StoreTimesheet,
    settings: StoreSettings,
    errors: PropertyNameIndexer,
    selectedWeek: Week | undefined,
    updateSelectedWeek: (selectedWeek: Week|undefined) => void 
};
